<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <!-- daily events summary -->
        <div class="col-6">
          <div class="table-responsive mb-0">
            <b-card-title> Daily Events Summary </b-card-title>
            <hr />
            <table class="table align-middle table-nowrap">
              <thead class="table-light">
                <tr>
                  <th class="align-middle"></th>
                  <th class="align-middle">Date</th>
                  <th class="align-middle">PKG 01</th>
                  <th class="align-middle">PKG 02</th>
                  <th class="align-middle">PKG 03</th>
                  <th class="align-middle">PKG 04</th>
                  <th class="align-middle">PKG 05</th>
                  <th class="align-middle">PKG 06</th>
                  <th class="align-middle">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in this.eventSummary" :key="data.date">
                  <td></td>
                  <td>
                    <a href="javascript: void(0);" class="text-body fw-bold">{{
                      data.date
                    }}</a>
                  </td>
                  <td>
                    {{ data.pkg01 }}
                  </td>
                  <td>{{ data.pkg02 }}</td>
                  <td>{{ data.pkg03 }}</td>
                  <td>{{ data.pkg04 }}</td>
                  <td>{{ data.pkg05 }}</td>
                  <td>{{ data.pkg06 }}</td>
                  <td>{{ data.total }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- daily accident summary -->
        <div class="col-6">
          <div class="table-responsive mb-4">
            <b-card-title> Daily Accidents Summary </b-card-title>
            <hr />
            <table class="table align-middle table-nowrap">
              <thead class="table-light">
                <tr>
                  <th class="align-middle"></th>
                  <th class="align-middle">Date</th>
                  <th class="align-middle">PKG 01</th>
                  <th class="align-middle">PKG 02</th>
                  <th class="align-middle">PKG 03</th>
                  <th class="align-middle">PKG 04</th>
                  <th class="align-middle">PKG 05</th>
                  <th class="align-middle">PKG 06</th>
                  <th class="align-middle">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in this.accidentSummary" :key="data.date">
                  <td></td>
                  <td>
                    <a href="javascript: void(0);" class="text-body fw-bold">{{
                      data.date
                    }}</a>
                  </td>
                  <td>
                    {{ data.pkg01 }}
                  </td>
                  <td>{{ data.pkg02 }}</td>
                  <td>{{ data.pkg03 }}</td>
                  <td>{{ data.pkg04 }}</td>
                  <td>{{ data.pkg05 }}</td>
                  <td>{{ data.pkg06 }}</td>
                  <td>{{ data.total }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-responsive mb-0">
            <table class="table align-middle table-nowrap">
              <thead class="table-light">
                <tr>
                  <th class="align-middle"></th>
                  <th class="align-middle">No Injury</th>
                  <th class="align-middle">Minor</th>
                  <th class="align-middle">Major</th>
                  <th class="align-middle">Fatal</th>
                  <th class="align-middle">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>31</td>
                  <td>43</td>
                  <td>47</td>
                  <td>21</td>
                  <td>12</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      eventSummary: [
        {
          date: "June",
          pkg01: 340,
          pkg02: 870,
          pkg03: 150,
          pkg04: 230,
          pkg05: 780,
          pkg06: 860,
          total: 651,
        },
        {
          date: "17/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
        {
          date: "16/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
        {
          date: "15/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
        {
          date: "14/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
        {
          date: "13/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
        {
          date: "12/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
        {
          date: "11/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
      ],

      accidentSummary: [
        {
          date: "June",
          pkg01: 340,
          pkg02: 870,
          pkg03: 150,
          pkg04: 230,
          pkg05: 780,
          pkg06: 860,
          total: 651,
        },
        {
          date: "17/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
        {
          date: "16/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
        {
          date: "15/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
        {
          date: "14/06",
          pkg01: 34,
          pkg02: 87,
          pkg03: 15,
          pkg04: 23,
          pkg05: 78,
          pkg06: 86,
          total: 651,
        },
      ],
    };
  },
};
</script>
